var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconAppetio({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_35116",
    "data-name": "Group 35116",
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_essen"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component_11_4",
    "data-name": "Component 11 \\u2013 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "pexels-moose-photos-1037999",
    width: 48,
    height: 48,
    rx: 15,
    fill: "#ffae4e",
    opacity: 0.2
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Asian_food",
    "data-name": "Asian food",
    transform: "translate(11.277 7.756)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Asian_food-2",
    "data-name": "Asian food",
    d: "M28.378,146.735a.9.9,0,0,0-1.239.315l-4.648,7.243c-.2-.3-.63-.427-.93-.63l3.718-7.558c.2-.407-.22-1.056-.62-1.26s-.73.223-.93.63L19.7,153.349h0a2.35,2.35,0,0,0-2.479-1.89,1.763,1.763,0,0,0-1.239.315,2.3,2.3,0,0,0-2.169-1.575,2.746,2.746,0,0,0-2.479,1.89,2.147,2.147,0,0,0-1.549-.63,2.46,2.46,0,0,0-2.479,2.519h0a2.8,2.8,0,0,1,1.239-.315,2.694,2.694,0,0,1,2.169,1.575,3.04,3.04,0,0,1,2.479-1.575,2.4,2.4,0,0,1,2.479,2.519v.315a2.5,2.5,0,0,1,1.239-.315,2.46,2.46,0,0,1,2.479,2.519,1.527,1.527,0,0,1-.31.945H3.588a1.8,1.8,0,0,0-1.549,1.89A12.01,12.01,0,0,0,14.124,173.5,11.749,11.749,0,0,0,25.9,161.537a1.676,1.676,0,0,0-.93-1.575,3.484,3.484,0,0,0,.31-.945A2.555,2.555,0,0,0,23.42,156.5l5.268-8.188A1.393,1.393,0,0,0,28.378,146.735ZM8.856,167.206A2.328,2.328,0,0,1,6.377,165a2.594,2.594,0,0,1,2.479-2.519A2.339,2.339,0,0,1,11.025,165,2.068,2.068,0,0,1,8.856,167.206Z",
    transform: "translate(-2.039 -144.793)",
    fill: "#ffae4e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAppetio);
export default __webpack_public_path__ + "static/media/icon-appetio.380f7052ffd831cb0480f25c0a804b3d.svg";
export { ForwardRef as ReactComponent };